<template>
	<v-dialog
		v-model="show"
		max-width="600px"
		persistent
	>
		<v-card>
			<v-card-title>
				Создание нового пользователя
			</v-card-title>
			<v-card-text>
				<v-form v-model="valid">
					<v-text-field
						required
						label="Имя пользователя"
						v-model="login"
						:rules="[required, v => min(v, 2), onlyLatin]"
					></v-text-field>
					<v-text-field
						v-model="password"
						:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
						:rules="[required, v => min(v, 6)]"
						:type="showPassword ? 'text' : 'password'"
						label="Пароль"
						hint="Минимум 6 знаков"
						counter
						@click:append="showPassword = !showPassword"
					></v-text-field>
					<v-select
						v-if="!addAdmin"
						label="Проекты доступные пользователю"
						no-data-text="Нет доступных проектов"
						multiple
						:items="projects"
						item-text="label"
						item-value="project"
						v-model="checkedProjects"
					>
					</v-select>
					<v-switch
						v-model="addAdmin"
						label="Администратор"
						color="primary"
					></v-switch>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-btn text @click="toggleAddUserDialog">Отмена</v-btn>
				<v-btn text color="success" @click="addUser" :disabled="!valid">Создать</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
  import asyncQuery from "../../../asyncQuery";

  export default {
    name: "AddUserDialog",
    data: () => {
      return {
        valid: false,
        login: '',
        password: '',
        showPassword: false,
        checkedProjects: [],
        addAdmin: false,
      }
    },
    props: {
      isOpen: Boolean,
      toggleAddUserDialog: Function,
      projects: Array,
      getUsers: Function,
      toggleLoading: Function,
    },
    methods: {
      // валидация полей
      required: value => !!value || 'Это обязательное поле.',
      min: (v, l) => v.length >= l || `Это поле должно содержать минимум ${l} сим.`,
      onlyLatin: value => {
        for (const s of value) {
          if ((s.charCodeAt() < 97 || s.charCodeAt() > 122)
            && (s.charCodeAt() < 65 || s.charCodeAt() > 90)
            && (s.charCodeAt() < 48 || s.charCodeAt() > 57)
            && s !== '.'
            && s !== '_'
            && s !== '-') return 'Допустимые символы: A-z, 0-9, _, -, .';
        }
        return true
      },

      cleanFields: function () {
        this.$data.login = '';
        this.$data.password = '';
        this.$data.checkedProjects = [];
        this.$data.addAdmin = false;
      },
      addUser: function () {
        asyncQuery.bind(this)({
          url: '/auth/register',
          method: 'POST',
          body: JSON.stringify({
            login: this.login,
            password: this.password,
            roles: this.addAdmin
              ? ['admin']
              : this.checkedProjects,
          }),
          handleSuccess: () => {
            this.toggleAddUserDialog();
            this.getUsers();
          },
        })
      },
    },
    computed: {
      show: {
        get: function () {
          return this.isOpen
        },
        set: function () {
          this.toggleAddUserDialog();
        }
      }
    },
    watch: {
      show: function (val) {
        if (val) this.cleanFields();
      },
    },
  }
</script>

<style scoped>

</style>
